<script setup lang="ts"></script>

<template>
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.64683 7.64683L1.2937 7.99995L1.64683 8.35308L6.64683 13.3531L6.99995 13.7062L7.7062 13L7.35308 12.6468L2.7062 7.99995L7.35308 3.35308L7.7062 2.99995L6.99995 2.2937L6.64683 2.64683L1.64683 7.64683ZM7.64683 7.64683L7.2937 7.99995L7.64683 8.35308L12.6468 13.3531L13 13.7062L13.7062 13L13.3531 12.6468L8.7062 7.99995L13.3531 3.35308L13.7062 2.99995L13 2.2937L12.6468 2.64683L7.64683 7.64683Z"
            fill="#6E6E6E"
        />
    </svg>
</template>
